export default "__VITE_ASSET__BaY3N_bF__"